interface SkeletonProps {
  className?: string;
}

export default function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded ${className}`}
      style={{ backgroundColor: 'rgba(245, 245, 245, 0.08)' }}
    />
  );
}

export function PostCardSkeleton() {
  return (
    <div className="py-6" style={{ borderBottom: '1px solid var(--color-border)' }}>
      <Skeleton className="h-6 w-3/4 mb-3" />
      <Skeleton className="h-4 w-1/3 mb-3" />
      <Skeleton className="h-4 w-1/4 mb-4" />
      <Skeleton className="h-16 w-full mb-3" />
      <Skeleton className="h-4 w-24" />
    </div>
  );
}

export function TableSkeleton({ rows = 5, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <table className="w-full text-sm">
      <thead>
        <tr className="border-b border-border">
          {Array.from({ length: cols }).map((_, i) => (
            <th key={i} className="pb-2">
              <Skeleton className="h-4 w-20" />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, r) => (
          <tr key={r} className="border-b border-border">
            {Array.from({ length: cols }).map((_, c) => (
              <td key={c} className="py-3">
                <Skeleton className="h-4 w-full" />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
